import { cloneDeep } from 'lodash-es'
import type { IField, IImportModel } from '@/modules/admin/type'
import { AttributeType } from '@/models/catalogAttribute'

export default class FavoritesModel {
  modelPath: string
  fields: IField[]
  importInfo: Record<string, any>

  constructor(t) {
    this.modelPath = 'catalogs.favorites'
    this.importInfo = {
      isCatalogSpecificModel: true,
      validateArticle: true,
      uniqueConstraints: [
        { name: 'Constraint 1', fields: ['ArticleNumber'] },
      ],
    }
    // NOTE: Always use the clone of fields never change the property directly on field
    this.fields = this.getFields(t)
  }

  private getFields(t) {
    const fields: IField[] = [
      { SystemName: 'ArticleNumber', DisplayName: t('favorites.articleNumber'), Visible: true, Creatable: true, Editable: false, AttributeType: AttributeType.Nvarchar, IsRequired: true, minLength: 1, autoMap: ['model', 'modelnumber', 'model number', 'style number', 'stylenumber', 'stylenbr'] } as IField,
      { SystemName: 'Tags', DisplayName: t('favorites.tags'), Visible: false, Creatable: true, Editable: false, AttributeType: AttributeType.Tags, TagSeparator: '|', IsRequired: true, minLength: 1 } as IField,
    ]
    return fields
  }

  getImportData() {
    const importInfo = cloneDeep(this.importInfo)
    return { importInfo, modelPath: this.modelPath, fields: this.fields } as IImportModel
  }
}
